import * as Sentry from "@sentry/browser";
import Cookie from "js-cookie";
import { createRoot } from "react-dom/client";
import { pdfjs } from "react-pdf";

import { initI18n } from "./i18n";
import logger from "./log";

pdfjs.GlobalWorkerOptions.workerSrc = new URL("npm:pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();

const errorLogger = logger("app:errors");

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    beforeSend: (event, hint) => {
      const error = hint.originalException ?? hint.syntheticException ?? event.message;
      if (error) errorLogger("%O", error);
      return event;
    },
    dsn: "https://7a39720e837da4dd86d7488c4b521aef@o73137.ingest.us.sentry.io/4512263967997952",
    environment: process.env.NODE_ENV,
    maxValueLength: 2500,
    release: `helloscreen-frontend@${process.env.CURRENT_APP_VERSION}`,
  });
}

window.reload = () => {
  sessionStorage.setItem("reload", "true");
  location.reload();
};

const importApp = import("./app");

const language = Cookie.get("upscope_locale") ?? navigator.language;
void initI18n(language)
  .then(async () => {
    return importApp;
  })
  .then(({ App }) => {
    const root = createRoot(document.querySelector("#root")!);

    root.render(<App />);
  });
